import useAgentData from '~/client/hooks/useAgentData';
import CollapsedCms from '~/client/shared/cms/CollapsedCms';
import GameCard from '~/client/shared/game/GameCard';
import Placeholder from '~/client/shared/LazyLoad/Placeholder';
import isListEmpty from '~/shared/utils/isListEmpty';
import GamesBreadcrumbs from './GamesBreadcrumbs';
import GameListItem from '../GameListItem';
import GamesContainer from '../GamesContainer';
import useGames from '../hooks/useGames';
import LoadMore from '../LoadMore';

type Props = {
  isLiveRtp?: boolean;
  isRecommendedGames?: boolean;
  pageSection: PageSection;
  cmsHandle?: string;
  isGridVisible: boolean;
  menuItem?: string;
  theme?: string;
  pageTitle?: string;
  width: number;
  placeholder: React.JSX.Element;
  isMinMaxBetVisible?: boolean;
  isBreadcrumbsVisible?: boolean;
  page: number;
};

const GameListPage: FC<Props> = ({
  menuItem,
  theme,
  pageTitle,
  isLiveRtp,
  pageSection,
  cmsHandle,
  isGridVisible,
  placeholder,
  width,
  isRecommendedGames,
  isMinMaxBetVisible,
  isBreadcrumbsVisible,
  page,
}) => {
  const { isDesktop } = useAgentData();
  const handle = menuItem === 'live-casino' ? 'live-dealer' : menuItem;
  const {
    games,
    loading,
    count,
    totalCount,
    rtpField,
    providerName,
    onLoadMore,
  } = useGames({ menuItem: handle, theme, isLiveRtp, isRecommendedGames });

  if (loading && isListEmpty(games)) {
    return <>{placeholder}</>;
  }

  const items = games?.map(({ node }, index) => {
    if (!node) {
      return null;
    }
    if (isGridVisible) {
      return (
        <GameCard
          key={node.id}
          game={node}
          rtpField={rtpField}
          big={isDesktop}
          showGrid
          isMinMaxBetVisible={isMinMaxBetVisible}
          sourcePage={pageSection}
          gridIndex={index + 1}
          page={page}
        />
      );
    }
    return <GameListItem key={node.id} game={node} />;
  });

  return (
    <>
      <GamesContainer width={width} isGridVisible={isGridVisible}>
        {items}
      </GamesContainer>

      {!isRecommendedGames && (
        <LoadMore
          handleLoadMore={onLoadMore}
          loading={loading}
          count={count}
          totalCount={totalCount}
        />
      )}
      <CollapsedCms
        section="category-seo"
        handle={cmsHandle}
        placeholder={<Placeholder height={280} />}
      />
      {!isBreadcrumbsVisible && (
        <GamesBreadcrumbs
          pageSection={pageSection}
          pageTitle={pageTitle}
          providerName={providerName}
        />
      )}
    </>
  );
};

export default GameListPage;
